import { useHistory, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

// Helper function to check if user has access to a specific directory
export const hasDirectoryAccess = (auth, requiredDirectory) => {
    if (!auth || !requiredDirectory) return false;
    
    // Admin has access to everything
    if (auth.role === 'admin') return true;
    
    // Check if user has access to the required directory
    // Check both auth.directories and auth.ek_permission.directories
    const directories = auth.directories || auth.ek_permission?.directories;
    return directories?.some(dir => {
        if (dir === '/*') return true;
        if (dir === requiredDirectory) return true;
        return false;
    }) || false;
};

export const AuthorizationCheck = (auth, requiredDirectory=null, redirect=true) => {
    
    const [renderPage, setRenderPage] = useState(false);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        
        if ( auth?.id !== undefined ) {
            
                window.dataLayer = window.dataLayer || [];
            
                // Push userId to the dataLayer
                window.dataLayer.push({
                    userId: auth?.id,
                });
        
            
        }
    }, [auth?.id]); // Runs when the `userId` changes or on first render

    useEffect(() => {
        //console.log(auth?.permission);
        switch( true ){
            case auth === null:
                setRenderPage( false );
                break;
            case Object.keys(auth).length === 0:
                if ( redirect ) {
                    history.push("/");
                }
                else {
                    setRenderPage( false );
                }
                break;
            case auth && auth?.permission === undefined:
                // User is logged in but has no permissions (legacy users)
                // Allow access to basic functionality
                if (requiredDirectory) {
                    // Check if user has access to required directory
                    const directories = auth.directories || auth.ek_permission?.directories;
                    const hasAccess = directories?.some(dir => {
                        if (dir === '/*') return true;
                        if (dir === requiredDirectory) return true;
                        return false;
                    });
                    
                    if (hasAccess || auth.role === 'admin') {
                        setRenderPage(true);
                    } else {
                        if (redirect) {
                            history.push("/");
                        } else {
                            setRenderPage(false);
                        }
                    }
                } else {
                    setRenderPage(true);
                }
                break;
            case auth?.role === 'admin':
                // Admin has access to everything
                setRenderPage( true );
                break;
            case auth?.role === 'user':
                // Regular user - check directory permissions
                if (requiredDirectory) {
                    const directories = auth.directories || auth.ek_permission?.directories;
                    const hasAccess = directories?.some(dir => {
                        if (dir === '/*') return true;
                        if (dir === requiredDirectory) return true;
                        return false;
                    });
                    
                    if (hasAccess) {
                        setRenderPage(true);
                    } else {
                        if (redirect) {
                            history.push("/");
                        } else {
                            setRenderPage(false);
                        }
                    }
                } else {
                    setRenderPage(true);
                }
                break;
            default:
                setRenderPage( true );
                break;
        }
    }, [auth, history, requiredDirectory, location, redirect]);
    
    return renderPage;
};